var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_info_-_outline",
    "data-name": "icon - info - outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 22,
    height: 22,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M-35,17.8a6.508,6.508,0,0,1-6.5-6.5A6.507,6.507,0,0,1-35,4.8a6.507,6.507,0,0,1,6.5,6.5A6.508,6.508,0,0,1-35,17.8Zm0-12.235A5.741,5.741,0,0,0-40.735,11.3,5.741,5.741,0,0,0-35,17.035,5.741,5.741,0,0,0-29.265,11.3,5.741,5.741,0,0,0-35,5.565Zm.382,2.676h-.765v.816h.765Zm0,2.039h-.765v4.078h.765Z",
    transform: "translate(46)",
    fill: "#cbcbcb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.8141f5076d1d9891cce7e7042a427788.svg";
export { ForwardRef as ReactComponent };